// extracted by mini-css-extract-plugin
export default {"container":"rVVQ","header":"fbzq","removeIconWrapper":"wxIJ","modalStyles":"c90V"};